<template>
  <div class="board">
    <div @click="signOut" class="power">
      <i style="cursor: pointer; font-size: 0.55rem" class="el-icon-back"></i>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" src="@/assets/logo_light.png" />
    </div>
		
<!-- 		<header class="w-100 h-10 flex j-center a-center">
				<div  class="font-big font-weight light-title">
				  {{ title ? title : "快反每日质量状态" }}
				</div>
		 </header> -->
		
		
		
   <header>
      <el-button class="title" type="primary">{{ title }}</el-button>
    </header>
    <div style="width: 100%; height: 100%" class="bgqt">
      <div
        style="
          border: 0px solid red;
          position: absolute;
          height: 45%;
          width: 28%;
          top: 20%;
          left: 35%;
        "
      >
        <div class="w-100 h-100" id="deptCloseRateEchart"></div>
      </div>
      <div style="position: absolute; left: 12%; top: 15%">
        <el-dropdown @command="monthFilter" trigger="click">
          <el-button style="color: black; font-size: 26px; font-weight: bold"
            >{{ month }}月</el-button
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="m" v-for="(m, r) in monthArry" :key="r"
              ><span style="color: black; font-size: 22px; font-weight: bold"
                >{{ m }}月</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div style="position: absolute; right: 12%; top: 15%">
        <el-dropdown @command="yearFilter" trigger="click">
          <el-button style="color: black; font-size: 26px; font-weight: bold">
            {{ year }}年 度
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="y" v-for="(y, r) in yearArry" :key="r"
              ><span style="color: black; font-size: 22px; font-weight: bold"
                >{{ y }} 年</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        style="position: absolute; right: 15%;bottom: 20%;color:black;font-size;width:100px;"
      >
        <el-row :gutter="20">
          <el-col style="margin: 10px" :span="24"
            ><el-button
              type="info"
              style="
                background-color: green;
                color: white;
                font-weight: bold;
                text-align: left;
              "
              plain
              >绿色 没有质量事故</el-button
            ></el-col
          >
          <el-col style="margin: 10px" :span="24"
            ><el-button
              type="warning"
              style="
                background-color: yellow;
                color: black;
                font-weight: bold;
                text-align: left;
              "
              plain
              >黄色 内部质量事故<br /><br />（内部定义）</el-button
            ></el-col
          >
          <el-col style="margin: 10px" :span="24"
            ><el-button
              type="danger"
              style="
                background-color: red;
                color: white;
                font-weight: bold;
                text-align: left;
              "
              plain
              >红色 客户质量事件<br /><br />（客户抱怨、PRR、PULL、SPILL）</el-button
            ></el-col
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import format from "date-fns/format";
import router from "../../../router";
export default {
  name: "board",
  data() {
    return {
      activeName: "first",
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      title: "快反每日质量状态",
      msg: "home",
      dataSet: {},
      loading: null,
      now: new Date(),
      year: 2021,
      month: 12,
      yearArry: [],
      monthArry: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  mounted() {
    this.initDate();
    this.onShow();
    this.webSocket();
    this.loadData(); //保留http
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    tabClick() {
      this.init();
    },
    signOut() {
      router.back();
    },
    initDate() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      for (var i = 0; i < 5; i++) {
        this.yearArry.push(year - i);
      }
      this.now = now;
      this.year = year;
      this.month = month;
    },
    monthFilter(m) {
      this.month = m;
      this.loadData();
    },
    yearFilter(y) {
      this.year = y;
      this.loadData();
    },
    loadData() {
      var now = new Date();
      now.setFullYear(this.year);
      now.setMonth(this.month - 1);
      this.now = now;
      var params = { begin: now.setHours(0, 0, 0, 0) + "" };
      this.startLoading();
      API.getQplot(params)
        .then((res) => {
          if (res.success == true) {
            this.dataSet = res.value;
            this.init();
          } else {
            this.$message.error(res.message);
          }
          this.endLoading();
        })
        .catch((error) => {
          this.$message.error("网络错误,数据查询失败");
          this.endLoading();
        });
    },
    init() {
      var lineEchart = this.$echarts.init(
        document.getElementById("deptCloseRateEchart")
      );
      var ym = format(this.now, "yyyy-MM");
      var data = this.dataSet;
      var lunarData = [];
      for (var key in data) {
        lunarData.push([key, data[key]]);
      }

      var option = {
        visualMap: {
          type: "piecewise", // 类型为分段型
          show: false,
          calculable: true,
          seriesIndex: [1],
          orient: "horizontal",
          left: "center",
          bottom: 20,
          pieces: [
            // 自定义每一段的范围，以及每一段的文字
            { lt: 0, color: "white" },
            { lt: 1, color: "green" },
            { lt: 2, color: "yellow" },
            { gt: 1, color: "red" },
          ],
        },

        calendar: [
          {
            left: "center",
            top: "middle",
            cellSize: ["auto", 35],
            yearLabel: { show: false },
            orient: "vertical",
            dayLabel: {
              firstDay: 1,
              nameMap: "cn",
            },
            monthLabel: {
              show: false,
            },
            range: ym,
          },
        ],
        series: [
          {
            type: "scatter",
            coordinateSystem: "calendar",
            symbolSize: 1,
            label: {
              show: true,
              formatter: function (params) {
                return new Date(params.value[0]).getDate();
              },
              color: "#000",
              fontSize: 18,
              fontWeight: 400,
            },
            data: lunarData,
          },
          {
            type: "heatmap",
            coordinateSystem: "calendar",
            symbolSize: 1,
            data: lunarData,
          },
        ],
      };

      lineEchart.setOption(option);
    },
    fmData() {
      var datas = this.dataSet["data"];
      var index = 1;
      datas.forEach((re) => {
        re.data.forEach((m) => {
          m.list.forEach((d) => {
            var status = "-1";
            if (d.dayList.length > 0) {
              var temp = null;
              d.dayList.forEach((t) => {
                var tmStatus = t["status"];
                if (tmStatus == "3") {
                  temp = tmStatus;
                } else if (!"3" == temp && !"2" == tmStatus) {
                  temp = tmStatus;
                } else {
                  temp = tmStatus;
                }
              });
              status = temp;
            }
            d["status"] = status;
          });
          m["index"] = index;
          index++;
        });
      });
    },
    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },

    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Qplot socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Qplot socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" Qplot socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        console.log(time);
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/qplot/board.vue